import { Grid } from '@mui/material';
import { VyLoader } from '../../../../components/new-design/feedback/Loader/VyLoader.tsx';

export const PlanViewLoader: React.FC = () => (
  <>
    <VyLoader height="132px" />
    <Grid container spacing={2} sx={{
      padding: "16px 0px"
    }}>
      <Grid
        size={{
          xs: 12,
          md: 6
        }}>
        <VyLoader />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6
        }}>
        <VyLoader />
      </Grid>
    </Grid>

    <VyLoader />
    <VyLoader sx={{ marginTop: '16px', borderRadius: '8px' }} />
  </>
);
